import { render, staticRenderFns } from "./asset-kpis.vue?vue&type=template&id=3be771a0&"
import script from "./asset-kpis.vue?vue&type=script&lang=js&"
export * from "./asset-kpis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3be771a0')) {
      api.createRecord('3be771a0', component.options)
    } else {
      api.reload('3be771a0', component.options)
    }
    module.hot.accept("./asset-kpis.vue?vue&type=template&id=3be771a0&", function () {
      api.rerender('3be771a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/consolidator/components/details-asset/asset-kpis.vue"
export default component.exports